import React from 'react';
import ReactLoading from 'react-loading';
import styles from './styles.scss';

interface BaseProps {
  content: string;
}

const LoadingBox: React.FC<BaseProps> = (props) => {
  const { content } = props;
  return (
    <div className={styles['mask-wrap']}>
      <div className={styles['loading-content']}>
        <ReactLoading width={28} height={28} type="spokes" color="#fff" />
        <p className={styles['text']}>{content}</p>
      </div>
    </div>
  );
};
export default LoadingBox;
